module.exports = "<symbol id=\"tt-icon-social-google\" viewBox=\"0 0 24 24\"><path d=\"M.47 11.41A11.77 11.77 0 0 1 12.23.21a12 12 0 0 1 7.88 2.91 42 42 0 0 1-3 3.1C14.44 4.37 10.63 3.84 7.95 6a7.55 7.55 0 0 0-.32 11.77C11.21 21 18 19.39 19 14.41c-2.25 0-4.5 0-6.75-.07v-4h11.27c.23 3.15-.19 6.51-2.13 9.12C18.44 23.57 12.55 24.77 8 23A11.8 11.8 0 0 1 .47 11.41z\" fill=\"#fff\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/non-defined-page/social-google.svg
// module id = 189
// module chunks = 11